module.exports = __webpack_public_path__ + "img/workers.9383eaa5.svg";